import Header from '../../components/common/header/index.vue'
import Bottom from '@/components/common/bottom/index.vue'
import axios from 'axios'
import { encryptRSA } from '../../util/rsa'
import { validatePasswordStrength } from '../../util/password'
export default {
  name: 'personInfo',
  components: { Header, Bottom },
  data () {
    // 手机号校验
    const validatePhone = (rule, value, callback) => {
      if (value) {
        const isPhone = /^((0\d{2,3})-)(\d{7,8})(-(\d{3,}))?$/
        const reg = /^(?:(?:\+|00)86)?1[3-9]\d{9}$/
        if (!reg.test(value) && !isPhone.test(value) && value) {
          callback(new Error('请输入正确的手机号'))
        } else {
          callback()
        }
      } else {
        callback(new Error('请输入手机号'))
      }
    }
    // 邮箱校验
    const validateEmail = (rule, value, callback) => {
      const reg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/
      if (value === '') {
        callback(new Error('请输入邮箱'))
      } else if (!reg.test(value)) {
        callback(new Error('请输入正确格式的邮箱'))
      } else {
        callback()
      }
    }

    // 验证码校验
    const validateCode = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入验证码'))
      } else {
        callback()
      }
    }

    const validatePassNew = (rule, value, callback) => {
      const errorMessage = validatePasswordStrength(value, this.name)
      if (errorMessage) {
        callback(new Error(errorMessage))
      } else if (value === this.setPsdForm.password) {
        callback(new Error('新密码不能与原密码一致'))
      } else {
        if (this.setPsdForm.confirmPassword !== '') {
          this.$refs.psdForm.validateField('confirmPassword')
        }
        callback()
      }
    }
    const validatePassConfirm = (rule, value, callback) => {
      const errorMessage = validatePasswordStrength(value, this.name)
      if (errorMessage) {
        callback(new Error(errorMessage))
      } else if (value === this.setPsdForm.password) {
        callback(new Error('新密码不能与原密码一致'))
      } else if (value !== this.setPsdForm.newPassword) {
        callback(new Error('两次输入密码不一致'))
      } else {
        callback()
      }
    }
    return {
      loading: false,
      visibleForm: true, // 提交申请表单
      // 导航信息
      navi: [{
        name: '登录信息',
        id: 'login'
      }, {
        name: '申请课题权限',
        id: 'authority'
      }, {
        name: '申请记录',
        id: 'apply'
      }],
      form: {
        address: '',
        branch: '',
        phone: '',
        reason: '',
        first: false,
        firstDesc: '作为科研人员，可通过申报、新建、认领等方式添加课题，提交课题材料',
        second: false,
        secondDesc: '作为评审专家，可评审分配给自己的课题'
      },
      naviSelect: 'login',
      // 用户名
      name: localStorage.getItem('name') || '',
      // 真实姓名
      userName: '',
      phone: '',
      // 邮箱
      email: '',
      // 互联网用户还是机构用户
      isHLW: 1,
      passwordList: [{}, {}, {}, {}, {}, {}],
      // 手机号弹窗显示
      visiblePhone: false,
      setPhoneForm: {
        old: '',
        new: '',
        password: ''
      },
      // 申请课题权限校验
      setAuthorityrules: {
        address: [
          { required: true, message: '请输入工作单位', trigger: 'blur' }
        ],
        branch: [
          { required: true, message: '请输入部门', trigger: 'blur' }
        ],
        phone: [
          { required: true, validator: validatePhone, trigger: 'blur' }
        ],
        reason: [
          { required: true, message: '请输入申请原因', trigger: 'blur' }
        ]
      },
      // 修改手机号的校验规则
      setPhonerules: {
        old: [
          { validator: validatePhone, trigger: 'blur' }
        ],
        new: [
          { validator: validatePhone, trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ]
      },
      // 邮箱弹窗是否显示
      visibleEmail: false,
      // 修改邮箱form
      setEmailForm: {
        email: '',
        checkCode: ''
      },
      // 修改邮箱的校验规则
      setEmailrules: {
        email: [
          { validator: validateEmail, trigger: 'blur' }
        ],
        checkCode: [
          { validator: validateCode, trigger: 'blur' }
        ]
      },
      // 修改密码弹窗显示
      visiblePsd: false,
      // 新旧密码
      setPsdForm: {
        password: '',
        newPassword: '',
        confirmPassword: ''
      },
      setPsdrules: {
        password: [
          { required: true, message: '请输入旧密码', trigger: 'blur' }
        ],
        newPassword: [
          { validator: validatePassNew, trigger: 'blur' }
        ],
        confirmPassword: [
          { validator: validatePassConfirm, trigger: 'blur' }
        ]
      },
      tableData: [],
      pageNo: 1,
      pageSize: 10,
      total: 0
    }
  },
  // 创建元素
  mounted () {
    this.init()
  },
  // 方法定义
  methods: {
    init () {
      this.getUserInfo()
    },

    // 跳转申请系统权限
    goApplyRight () {
      const applyRight = this.$router.resolve({ path: '/applyRight' })
      window.open(applyRight.href, '_blank')
    },
    // 获取用户信息
    getUserInfo () {
      const self = this
      axios.get('/yuhuamenhu/user/getUserFromRedis').then(json => {
        if (json.status === 200) {
          self.name = json.data.name
          self.userName = json.data.userName
          self.email = json.data.mail
          self.phone = json.data.phone
          self.isHLW = json.data.isHLW
        } else {
          self.$message.warning(json.data.message)
        }
      }).catchcancelPhone(err => {
        console.log(err)
      })
    },
    // 保存前校验
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submitAPI()
        } else {
          this.$message.warning('请填写个人申请信息!')
          console.log('error submit!!')
          return false
        }
      })
    },
    // 申请课题权限 提交
    submitAPI () {
      const descArray = []
      if (this.form.first) {
        descArray.push({
          name: '课题提交',
          description: this.form.firstDesc
        })
      }
      if (this.form.second) {
        descArray.push({
          name: '课题评审',
          description: this.form.secondDesc
        })
      }
      if (descArray.length === 0) {
        this.$message.warning('请选择需要申请的系统权限!')
        return
      }
      const query = {
        applyReason: this.form.reason,
        department: this.form.branch,
        phone: this.form.phone,
        unit: this.form.address,
        subjectPermissionList: descArray
      }
      axios.post('/yuhuamenhu/permissionApply/applySubject', query).then(res => {
        if (res.data.code === 200) {
          this.visibleForm = false
          this.form.reason = ''
          this.form.branch = ''
          this.form.phone = ''
          this.form.address = ''
          this.form.first = false
          this.form.second = false
        } else {
          this.$message.warning(res.data.errorMessage)
        }
      }).catch(err => {
        console.log(err)
      })
    },
    // 返回申请表单
    backForm () {
      this.visibleForm = true
    },
    // 导航点击
    clickNavi (id) {
      this.naviSelect = id
      this.visibleForm = true
      if (this.naviSelect === 'apply') {
        this.pageNo = 1
        this.getApplyList()
      }
    },
    // 打开手机弹窗
    handlePhone () {
      this.visiblePhone = true
    },
    // 关闭手机弹窗
    cancelPhone () {
      this.visiblePhone = false
      this.$refs.phoneForm.resetFields()
    },
    // 打开邮箱弹窗
    handleEmail () {
      this.visibleEmail = true
    },

    // 关闭邮箱弹窗
    cancelEmail () {
      this.visibleEmail = false
      this.$refs.emailForm.resetFields()
    },

    // 获取验证码
    getCheckcode () {
      if (this.setEmailForm.email === '') {
        this.$message.warning('请先输入邮箱!')
        return
      }
      const self = this
      axios.get('/yuhuamenhu/user/getCheckCode', {
        params: {
          mail: this.setEmailForm.email
        }
      }).then(json => {
        if (json.data.code === 200) {
          self.$message.success(json.data.data)
        } else {
          self.$message.warning(json.data.errorMessage)
        }
      }).catch(err => {
        console.log(err)
      })
    },
    // 修改手机号保存
    submitPhone (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.setNewPhone()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 修改新手机号
    setNewPhone () {
      // 盐值
      // const salt = 'cnki-yyds*123.cv987@'
      const query = {
        newPhone: this.setPhoneForm.new,
        originalPhone: this.setPhoneForm.old,
        password: encryptRSA(this.setPhoneForm.password)
      }
      axios.post('/yuhuamenhu/personalCenter/modifyPhone', query).then(json => {
        if (json.data.code === 200) {
          this.$message.success(json.data.data)
          this.visiblePhone = false
          this.cancelPhone()
          this.getUserInfo()
        } else {
          this.$message.warning(json.data.errorMessage)
        }
      }).catch(err => {
        console.log(err)
      })
    },
    // 修改邮箱验证
    submitSave (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.setNewEmail()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },

    // 修改新邮箱
    setNewEmail () {
      const self = this
      const data = {
        mail: this.setEmailForm.email,
        code: this.setEmailForm.checkCode
      }
      axios.post('/yuhuamenhu/user/updateMail', data).then(json => {
        if (json.data.code === 200) {
          self.$message.success(json.data.data)
          self.visibleEmail = false
          self.cancelEmail()
          self.getUserInfo()
        } else {
          self.$message.warning(json.data.errorMessage)
        }
      }).catch(err => {
        console.log(err)
      })
    },

    // 打开修改密码弹窗
    handlePsd () {
      this.visiblePsd = true
    },

    // 关闭修改密码弹窗
    cancelPsd () {
      this.visiblePsd = false
      this.$refs.psdForm.resetFields()
    },

    // 修改密码检验
    submitPsd (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.uploadNewPsd()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },

    // 修改密码
    uploadNewPsd () {
      const self = this
      // 盐值
      // const salt = 'cnki-yyds*123.cv987@'
      const data = {
        oldPassword: encryptRSA(self.setPsdForm.password),
        newPassword: encryptRSA(self.setPsdForm.newPassword)
      }
      axios.post('/yuhuamenhu/user/updatePassword', data).then(json => {
        if (json.data.code === 200) {
          self.$message.success(json.data.data)
          self.cancelPsd()
          self.signOut()
        } else {
          self.$message.warning(json.data.errorMessage)
        }
      }).catch(err => {
        console.log(err)
      })
    },

    // 退出登录
    signOut () {
      const self = this
      axios.post('/yuhuamenhu/user/logout').then(json => {
        if (json.data.code === 201) {
          self.$store.commit('del_Authorization')
          self.$store.commit('del_name')
          self.$store.commit('del_userName')
          self.$store.commit('del_userType')
          self.$store.commit('del_userKind')
          this.$router.replace({
            path: '/login'
          })
        } else {
          self.$message.warning(json.data.errorMessage)
        }
      }).catch(err => {
        console.log(err)
      })
    },

    // 获取申请记录list
    getApplyList () {
      const self = this
      self.loading = true
      const data = {
        pageNo: this.pageNo,
        pageSize: this.pageSize
      }
      axios.post('/yuhuamenhu/permissionApply/listPageApplyRecord', data).then(json => {
        if (json.data.code === 200) {
          self.total = json.data.data.total
          self.tableData = self.upDate(json.data.data.list)
        } else {
          self.$message.warning(json.data.errorMessage)
        }
      }).catch(err => {
        console.log(err)
      }).finally(() => {
        self.loading = false
      })
    },

    // 处理表格数据
    upDate (list) {
      list.forEach(item => {
        // let permissionStr = ''
        // item.permission = JSON.parse(item.permission)
        // item.permission.forEach(itemC => {
        //   console.log(itemC);
        //   permissionStr = permissionStr + itemC.name + '；'
        // })
        // item.permissionStr = permissionStr
        switch (item.reviewStatus) {
          case 0:
            item.status = '未审核'
            break
          case 1:
            item.status = '已通过'
            break
          case 2:
            item.status = '不通过'
            break
        }
      })
      return list
    },

    changePage (val) {
      this.pageNo = val
      this.getApplyList()
    }
  }
}
